import {trackPageView} from '../utils/analytics';

// See https://github.com/react-ga/react-ga/blob/master/demo/app/withTracker.jsx
export function withTracker(page) {
    trackPageView(page).catch(() => {
    });
}
